import ScrollableSection, { ScrollableSectionProps } from './ScrollableSection';

export type { ScrollableSectionProps };
export default ScrollableSection;
